var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","overflow":"auto"}},[_c('h5',[_vm._v(_vm._s(_vm.bdtns_no))]),_c('table',{staticClass:"tablet"},_vm._l((_vm.tablet_content),function(line){return _c('tr',{key:line[1],class:{'highlighted': _vm.highlights.includes(line[1])}},[_c('td',[_vm._v(_vm._s(line[1]))]),_c('td',[_vm._v(_vm._s(line[2]+' '+line[3]+' '+line[4]))]),_c('td',[_vm._v(_vm._s(line[5]))])])}))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e10ce900","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BDTNSView.vue
// module id = null
// module chunks = 